import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialMultipleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const cancelAdminEventReducer = createReducer<State, Actions>(initialState, {
  [actions.cancelAdminEvent.request.type]: actionsHandlers.handleMultipleFeatureRequest,
  [actions.cancelAdminEvent.success.type]: actionsHandlers.handleMultipleFeatureSuccess,
  [actions.cancelAdminEvent.failure.type]: actionsHandlers.handleMultipleFeatureFailure,
  [actions.cancelAdminEvent.reset.type]: actionsHandlers.handleMultipleFeatureReset,
});

export default cancelAdminEventReducer;
